/**
 * Точка входа webpack: landing.tools
 */
import './tools.css';
import '../../common.js';
import '../../modules/partners/partners.js';

function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function escapeHtml(str) {
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

function highlightText(el, originalText, queryRaw) {
    if (!queryRaw) {
        el.textContent = originalText;
        return;
    }

    const escapedOriginal = escapeHtml(originalText);
    const re = new RegExp(escapeRegExp(queryRaw), 'gi');
    el.innerHTML = escapedOriginal.replace(re, (match) => `<mark>${match}</mark>`);
}

function restoreText(el, originalText) {
    el.textContent = originalText;
}

/**
 * Редирект на отдельную страницу бесплатных инструментов по #free.
 * На /tools/free не срабатывает, чтобы не уйти на /tools/free/free.
 */
function redirectFreeHash() {
    const { pathname, origin, hash } = window.location;
    const path = pathname.replace(/\/$/, '');
    if (hash.replace(/^#/, '') === 'free' && !path.endsWith('/free')) {
        window.location.replace(`${origin}${path}/free`);
        return true;
    }
    return false;
}

function initCatalog() {
    const itemsLink = document.querySelectorAll('#catalog-categories li');
    const items = document.querySelectorAll('#catalog-items .catalog__visible');
    const searchInput = document.querySelector('#catalog-search');
    const hasCategoryTabs = Boolean(document.querySelector('#catalog-categories [data-category]'));

    if (!items.length) {
        return;
    }

    let currentCategory = 'all';

    // На /tools/free категорий-фильтров нет — hash не должен прятать карточки
    if (hasCategoryTabs && window.location.hash) {
        const category = window.location.hash.replace('#', '');
        if (category.length > 0) {
            currentCategory = category;
        }
    }

    function applyFilters() {
        const queryRaw = (searchInput?.value || '').trim();
        const query = queryRaw.toLowerCase();

        items.forEach((item) => {
            const isCategoryVisible =
                currentCategory === 'all' ||
                item.classList.contains('catalog__visible--' + currentCategory);

            const titleEl = item.querySelector('h4');
            const descEl = item.querySelector('p');
            const hasToolCard = Boolean(titleEl);

            // Заголовки разделов скрываем при поиске, иначе фильтруем по категории
            if (!hasToolCard) {
                item.style.display = query ? 'none' : (isCategoryVisible ? 'flex' : 'none');
                return;
            }

            const titleOriginal = (titleEl.textContent || '').trim();
            const descOriginal = descEl ? (descEl.textContent || '').trim() : '';
            const title = titleOriginal.toLowerCase();
            const desc = descOriginal.toLowerCase();

            const matchesTitle = !query || title.includes(query);
            const matchesDesc = !query || desc.includes(query);
            const isSearchVisible = !query || matchesTitle || matchesDesc;
            const shouldShow = isCategoryVisible && isSearchVisible;

            item.style.display = shouldShow ? 'flex' : 'none';

            if (!titleEl.dataset.originalText) {
                titleEl.dataset.originalText = titleOriginal;
            }
            if (descEl && !descEl.dataset.originalText) {
                descEl.dataset.originalText = descOriginal;
            }

            const originalTitle = titleEl.dataset.originalText || titleOriginal;
            const originalDesc = descEl ? (descEl.dataset.originalText || descOriginal) : '';

            if (!query || !shouldShow) {
                restoreText(titleEl, originalTitle);
                if (descEl) {
                    restoreText(descEl, originalDesc);
                }
                return;
            }

            if (matchesTitle) {
                highlightText(titleEl, originalTitle, queryRaw);
            } else {
                restoreText(titleEl, originalTitle);
            }

            if (descEl) {
                if (matchesDesc) {
                    highlightText(descEl, originalDesc, queryRaw);
                } else {
                    restoreText(descEl, originalDesc);
                }
            }
        });
    }

    function setActiveCategory(category) {
        currentCategory = category;
        itemsLink.forEach((li) => {
            if (li.dataset.category === category) {
                li.classList.add('catalog__tab--active');
            } else if (li.dataset.category) {
                li.classList.remove('catalog__tab--active');
            }
        });
        applyFilters();
    }

    itemsLink.forEach((itemLink) => {
        itemLink.addEventListener('click', (e) => {
            const category = itemLink.dataset.category;
            if (!category) {
                return;
            }
            e.preventDefault();
            window.location.hash = category;
            setActiveCategory(category);
        });
    });

    setActiveCategory(currentCategory);
    searchInput?.addEventListener('input', applyFilters);
}

function init() {
    if (redirectFreeHash()) {
        return;
    }
    initCatalog();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
